module.exports = __webpack_public_path__ + "img/产品-暖通.b3e61614.png";